/* Sorenzia – mobile drawer grouping (Home / Shop / Help / About).
   Horizon's drawer markup is left intact; this adds the Sorenzia groups from
   <template id="sz-drawer-tpl"> and re-applies them if Horizon re-renders. */
(() => {
  if (window.__szNav) return;
  window.__szNav = true;

  function inject() {
    const tpl = document.getElementById('sz-drawer-tpl');
    if (!tpl) return;
    document.querySelectorAll('header-drawer .menu-drawer__navigation').forEach((nav) => {
      if (nav.querySelector('.sz-drawer__top')) return;
      const list = nav.querySelector(':scope > .menu-drawer__menu');
      if (!list) return;
      const part = (name) => tpl.content.querySelector(`[data-part="${name}"]`).cloneNode(true);
      nav.insertBefore(part('top'), list);
      list.after(part('after-list'));
      const drawer = nav.closest('.menu-drawer');
      if (drawer) {
        drawer.classList.add('sz-drawer');
        if (!drawer.querySelector('.sz-drawer__extras')) nav.after(part('extras'));
      }
    });
  }

  let queued = false;
  const schedule = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      inject();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', inject);
  } else {
    inject();
  }
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
})();
